import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "./DeleteEvaluation.css";

function DeleteEvaluation() {
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { eid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/periods/${eid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.period.name);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/periods/${eid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/evaluations");
    } catch (error) {
      toast(error.response.data.message);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col className="delete-evaluation">
            <Col>
              <h4>{t("Evaluaciones.DeleteEvaluation.Titulo")}</h4>
            </Col>
            <Col className="delete-evaluation-form">
              <Col className="mb-1">
                <p>{t("Evaluaciones.DeleteEvaluation.Pregunta")}</p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Evaluaciones.DeleteEvaluation.Eliminar")}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate("/evaluations")}
                >
                  {t("Evaluaciones.DeleteEvaluation.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteEvaluation;
